import { render, staticRenderFns } from "./TopBanner.vue?vue&type=template&id=0a47ed36&scoped=true"
import script from "./TopBanner.vue?vue&type=script&lang=js"
export * from "./TopBanner.vue?vue&type=script&lang=js"
import style0 from "./TopBanner.vue?vue&type=style&index=0&id=0a47ed36&prod&scoped=true&lang=css"
import style1 from "./TopBanner.vue?vue&type=style&index=1&id=0a47ed36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a47ed36",
  null
  
)

export default component.exports